import FormPage from "@/components/FormPage";
import { api, IMAGES } from "@/lib/api";

export default function Sponsor() {
    return (
        <FormPage
            testIdPrefix="sponsor"
            eyebrow="Sponsor"
            title="Become a Sponsor"
            tagline="fuel real change"
            description="Partner with Poppa & Gigi's Promise to fuel real, lasting change in the lives of grandparents raising grandchildren. Your sponsorship powers events, resources, and emergency support."
            heroImage={IMAGES.founders}
            accentColor="blue"
            fields={[
                { name: "name", label: "Your Name", required: true },
                { name: "email", label: "Email", type: "email", required: true },
                { name: "organization", label: "Organization (optional)", placeholder: "Company / brand" },
                {
                    name: "tier", label: "Sponsorship Tier", type: "select", required: true,
                    options: [
                        { value: "bronze", label: "Bronze — $250" },
                        { value: "silver", label: "Silver — $500" },
                        { value: "gold", label: "Gold — $1,000" },
                        { value: "platinum", label: "Platinum — $2,500+" },
                    ],
                },
                { name: "message", label: "Message", type: "textarea", placeholder: "Anything we should know?" },
            ]}
            submitLabel="Submit Sponsorship Interest"
            onSubmit={(v) => api.post("/sponsor", v)}
            successTitle="Thank you, partner!"
            successMessage="We'll reach out shortly to confirm the details of your sponsorship."
        />
    );
}
